import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { Rule } from '../settings.component'

const BASE_URL = environment.BASE_URL 

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http = inject(HttpClient);

  getRules(businessId?: string): Observable<any> {
    const url = `${BASE_URL}config?business_id=${businessId}`;
    const res = this.http.get(url);
    return res;
  }

  getCustomers(businessId?: string): Observable<any> {
    const url = `${BASE_URL}config/customers?business_id=${businessId}`;
    const res = this.http.get(url);
    return res;
  }

  createRules(businessId: string, rules: Rule[]): Observable<any> {
    const url = `${BASE_URL}config`;
    const res = this.http.post(url, {
        "BusinessID": businessId,
        "rules": rules,
    });
    return res;
  }
}
